import React from 'react';

import {
  CreateUpdateEstimateItemDto,
  GetPositionExtendedDto,
  GetProfileDto,
  GetProjectDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import ValidationAlert from '../../../app/components/ValidationAlert';

import { EstimateItemTabsFooter } from './EstimateItemTabsFooter';
import { EstimateItemGeneralForm } from './EstimateItemGeneralForm';
import { EstimateItemTabsPanel } from './EstimateItemTabsPanel';
import { useEstimateItemState } from './useEstimateItemState';

interface EstimateItemTabsProps {
  estimateItem: CreateUpdateEstimateItemDto;
  positionName?: string;
  id?: string;
  project?: GetProjectDto;
  profile?: GetProfileDto;
  isSalesBlocked: boolean;
  isPurchaseBlocked: boolean;
  propertyChange?: (obj: Partial<CreateUpdateEstimateItemDto>) => void;
  onCompleted: (
    item: CreateUpdateEstimateItemDto,
    id?: string,
    noOrderRequired?: boolean,
    position?: GetPositionExtendedDto,
  ) => Promise<{
    saved: boolean;
    errors: string[];
    amountFieldsValid?: boolean;
  }>;
  onDelete: (id?: string) => Promise<{
    saved: boolean;
    errors: string[];
  }>;
  cloneItem: (id: string, withAmounts: boolean) => () => void;
  closeAccordion: () => void;
}

export const EstimateItemTabs: React.FC<EstimateItemTabsProps> = props => {
  const {
    estimateItem,
    selectedPosition,
    specialistTeamOptions,
    activeTab,
    setActiveTab,
    showSaveErrors,
    saveErrors,
    isLoadingSave,
    isLoadingDelete,
    propertyChange,
    createEstimateItem,
    deleteItem,
    setNoOrderRequired,
  } = useEstimateItemState({
    estimateItem: props.estimateItem,
    id: props.id,
    project: props.project,
    profile: props.profile,
    onCompleted: props.onCompleted,
    onDelete: props.onDelete,
    closeAccordion: props.closeAccordion,
  });

  return (
    <>
      <EstimateItemGeneralForm
        estimateItem={estimateItem}
        project={props.project}
        profile={props.profile}
        selectedPosition={selectedPosition}
        specialistTeamOptions={specialistTeamOptions}
        propertyChange={obj => void propertyChange(obj)}
      />
      <EstimateItemTabsPanel
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        estimateItem={estimateItem}
        project={props.project}
        profile={props.profile}
        propertyChange={obj => void propertyChange(obj)}
        isSalesBlocked={props.isSalesBlocked}
        isPurchaseBlocked={props.isPurchaseBlocked}
        id={props.id}
        positionName={props.positionName}
        onNoOrderRequiredChange={setNoOrderRequired}
      />
      <ValidationAlert
        show={showSaveErrors}
        errors={saveErrors}
        className="m-3"
      />
      <EstimateItemTabsFooter
        id={props.id}
        deleteItem={deleteItem}
        createEstimateItem={createEstimateItem}
        cloneItem={props.cloneItem}
        isSalesBlocked={props.isSalesBlocked}
        isPurchaseBlocked={props.isPurchaseBlocked}
        isLoadingSave={isLoadingSave}
        isLoadingDelete={isLoadingDelete}
      />
    </>
  );
};
